/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemRevisionResultViewModel } from "../types/ExamItemRevisionResultViewModel.ts";
import { examItemCreateViewModelSchema } from "./examItemCreateViewModelSchema.ts";

export const examItemRevisionResultViewModelSchema = z.object({
  item: z.optional(z.lazy(() => examItemCreateViewModelSchema)),
  summary: z
    .string()
    .describe(
      "Resumo/opinião da IA sobre a questão, indicando se está correta ou incorreta e o motivo. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ExamItemRevisionResultViewModel>;
